"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textColors = exports.scaleColors = exports.legacyColors = exports.formColors = exports.eligibilityColors = exports.dataVisualisationColors = exports.baseColors = exports.backgroundColors = exports.alertColors = void 0;
var baseColors = exports.baseColors = {
  indigo20: '#eaebf7',
  indigo30: '#d6d8f0',
  indigo40: '#928cc8',
  indigo60: '#261a91',
  indigo80: '#170f57',
  indigo100: '#0f0a3a',
  indigo120: '#08051c',
  indigo140: '#05030f',
  coral60: '#ff9e8c',
  coral80: '#ff826b',
  coral100: '#ff6648',
  coral120: '#ff5634',
  coral140: '#ff3b14',
  teal10: '#c9f6e8',
  teal20: '#9ef2d8',
  teal40: '#77ecc9',
  teal60: '#3de5b2',
  teal80: '#1fe0a6',
  teal100: '#1ac490',
  teal120: '#17b585',
  teal140: '#17a67a',
  teal160: '#0b8761',
  yellow20: '#fff5d6',
  yellow40: '#fffda3',
  yellow60: '#f7f573',
  yellow80: '#f5f254',
  yellow100: '#f4ee22',
  yellow120: '#e8e30d',
  yellow140: '#d9d10a',
  warmYellow40: '#fdf5d9',
  warmYellow60: '#ffedb0',
  warmYellow80: '#fbe28a',
  warmYellow100: '#ffd664',
  neutral: '#f6f2f1',
  neutral60: '#faf8f8',
  neutral80: '#f7f5f5',
  neutral100: '#f5f2f1',
  neutral120: '#ede5e3',
  neutral160: '#e8e4e3',
  neutral140: '#e4d9d6',
  /**
   * @deprecated Use grey80
   */
  neutral200: '#5c5a6a',
  productNeutral60: '#faf8f8',
  productNeutral80: '#f7f5f5',
  productNeutral100: '#f5f2f1',
  productNeutral120: '#f2eeed',
  productNeutral140: '#eeeae9',
  productNeutral160: '#e8e4e3',
  grey20: '#f0f0f5',
  grey40: '#cccbd4',
  grey60: '#9a98ab',
  grey80: '#73738c',
  grey100: '#3a384b',
  grey120: '#08051c'
};
var alertColors = exports.alertColors = {
  alertError60: '#ffecf1',
  alertError100: '#ff8aa6',
  alertError120: '#d90a3c',
  alertSuccess100: '#a5ffc3',
  alertWarning100: '#ffe27c',
  alertInfo100: '#a3f4ff'
};

/**
 * @deprecated
 */
var legacyColors = exports.legacyColors = {
  almostWhite: '#f9fbfc',
  graphiteLight: '#f7f8f9',
  graphiteDarker: '#283643',
  wasabi: '#9de89f',
  pink: '#e0457b',
  greyLighter: '#e2e5e8',
  greyDarker: '#6f7d8a',
  greyLight: '#d8d8d8',
  boxShadowGrey: '#9e9e9e',
  amber: '#fae376',
  purple: '#cbceec',
  orangePumpkin: '#f78105',
  preApprovedGreen: '#127860'
};
var textColors = exports.textColors = {
  bodyTextColor: baseColors.neutral200,
  primaryColor: baseColors.indigo100,
  textColor: baseColors.indigo120,
  textColorLight: baseColors.grey100
};

// TODO - Need to review
var formColors = exports.formColors = {
  helperText: textColors.bodyTextColor,
  inputBorder: '#9c9ba5',
  errorLight: '#ffecf1',
  errorDark: '#d90a3c',
  warningLight: '#fdfdd4',
  warningDark: '#8a6d3b',
  sapphire: '#303bb2',
  cloudyBlue: '#bfc5cb',
  greyishBrown: '#4a4a4a',
  disabled: '#9c9ba5',
  veryLightBlue: '#e8e9ec',
  brownGrey: '#979797'
};
var eligibilityColors = exports.eligibilityColors = {
  eligibilityLevel0: '#127860',
  'eligibilityLevel0-bg10': '#E8F2F0',
  eligibilityLevel1: '#18ae71',
  'eligibilityLevel1-bg10': '#E8F7F1',
  'eligibilityLevel1-bg20': '#D1EFE3',
  'eligibilityLevel1-bg30': '#BAE7D4',
  eligibilityLevel2: '#9de89f',
  'eligibilityLevel2-bg10': '#F5FDF5',
  'eligibilityLevel2-bg20': '#EBF9EC',
  'eligibilityLevel2-bg30': '#E2F8E2',
  eligibilityLevel3: '#fae376',
  'eligibilityLevel3-bg20': '#FEF9E4',
  eligibilityLevel4: '#ffa269',
  'eligibilityLevel4-bg20': '#FFECE1',
  eligibilityLevel5: '#ff7b77',
  'eligibilityLevel5-bg20': '#FFE5E4'
};
var dataVisualisationColors = exports.dataVisualisationColors = {
  dataVisualisationTeal: '#1bcc96',
  dataVisualisationLightPurple: '#6e55e6',
  dataVisualisationOrange: '#fb8b24',
  dataVisualisationPaleBlue: '#a6e1fa',
  dataVisualisationPink: '#d8548a',
  dataVisualisationAegeanBlue: '#19647e',
  dataVisualisationCeruleanBlue: '#28a1d1',
  dataVisualisationDarkPurple: '#4439ab',
  dataVisualisationSkyBlue: '#1dc3ea',
  dataVisualisationTurquoise: '#00b0b5',
  dataVisualisationRed: '#e53942'
};

// TODO - Need to review
var backgroundColors = exports.backgroundColors = {
  backgroundLightBlue: '#e6f5f7',
  infoLightBlue: '#e4fcff'
};
var scaleColors = exports.scaleColors = {
  /**
   * @deprecated Use scaleLevel100
   */
  scaleLevel: '#6E55E6',
  scaleLevel20: '#F1EEFD',
  scaleLevel40: '#E2DDFA',
  scaleLevel60: '#C5BBF5',
  scaleLevel80: '#A899F0',
  scaleLevel100: '#6E55E6'
};